export { title, footnotes, buttons } from "../content";

export const intros = [
  {
    text: (
      <span>
        For 33 London boroughs
        <sup>1</sup>, we researched thousands of properties sold in the last 12
        months or currently on the market to find the average price of a
        three-bedroom property. For each market, we calculated exactly how long
        it would take you, in months, to recoup the property value based on
        average rental and Airbnb costs.
      </span>
    ),
    id: "airbnb-uk-london-intro",
  },
];
